import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import * as fromUser from './user.reducer';
import * as fromLogin from './login.reducer';
import { createFeatureSelector } from '@ngrx/store';
import { environment } from '../../../environments/environment';

// export const authFeatureKey = 'auth';

export interface AuthState {
  [fromLogin.loginFeatureKey]: fromLogin.State;
}

export const reducers: ActionReducerMap<AuthState> = {
  [fromLogin.loginFeatureKey]: fromLogin.reducer,
};


export const metaReducers: MetaReducer<AuthState>[] = !environment.production ? [] : [];

export const featureSelector = createFeatureSelector(fromLogin.loginFeatureKey);
